import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { SupplyPassportUser } from '../../types/types';

interface AuthState {
  user: SupplyPassportUser | null;
  isLoading: boolean;
}

const initialState: AuthState = {
  user: null,
  isLoading: true,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<SupplyPassportUser | null>) => {
      state.user = action.payload;
      state.isLoading = false; // session check done
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUser, setLoading } = authSlice.actions;
export default authSlice.reducer;
